var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{class:[
    'meta col-12 row cursor-pointer shadow-1',
    _vm.isSelected ? 'unfocus' : '',
  ],style:(_vm.metaBackground),attrs:{"bg-primary":""},on:{"mouseover":function($event){return _vm.metaOver()},"mouseleave":function($event){return _vm.metaLeave()},"click":function($event){return _vm.openURL()}}},[_c('div',{staticClass:"row col-12"},[_c('div',{class:['title-container']},[_c('div',[_vm._v(_vm._s(_vm.metaName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }